import { appendQueryString } from "./api/appendQueryString";
import type { PPAInvoiceId } from "./components/PPAInvoicing/PPAInvoicesPage/PPAInvoicePage.types";

const neWebUrls = {
  api: {
    ppaDirectDeliveryContracts: (start?: string, end?: string) =>
      appendQueryString("/api/v2/ppa/direct-delivery/contracts/", {
        start,
        end
      }),
    ppaDirectDeliveryInvoices: () => "/api/v2/ppa/direct-delivery/invoices/",
    ppaDirectDeliveryInvoiceDriftDetection: () =>
      "/api/v2/ppa/direct-delivery/invoices/drift-detection/",
    ppaDirectDeliveryInvoiceGenerateDraft: (invoiceId: PPAInvoiceId) =>
      appendQueryString("/api/v2/ppa/direct-delivery/invoice/draft/", {
        unique_identifier: invoiceId
      }),
    generateInvoice: () => "/api/v2/ppa/direct-delivery/invoice/",
    ppaSendInvoice: () => "/api/v2/ppa/direct-delivery/invoice/send/",
    ppaVoidInvoice: () => "/api/v2/ppa/direct-delivery/invoice/void/",
    ppaInvoice: (invoiceId: PPAInvoiceId) =>
      appendQueryString("/api/v2/ppa/direct-delivery/invoice/", {
        unique_identifier: invoiceId
      }),
    ppaInvoiceNumberRanges: () => "/api/v2/ppa/invoice-number-ranges/",
    ppaInvoiceNumberRange: (rangeId: string) =>
      `/api/v2/ppa/invoice-number-ranges/${rangeId}`,
    ppaInvoiceNumberRangeSuppliers: () =>
      "/api/v2/ppa/invoice-number-ranges/suppliers",
    aiChatFeedback: () => "/api/v2/ai-chat/feedback",
    aiChatAdminFeedback: (rating: string, days: number, limit: number) =>
      appendQueryString("/api/v2/ai-chat/admin/feedback", {
        rating,
        days,
        limit
      })
  }
};

const neWebQueryKeys = {
  ppaInvoicing: {
    all: () => "ppaInvoicing",
    invoiceNumberRanges: () => [
      neWebQueryKeys.ppaInvoicing.all(),
      "invoiceNumberRanges"
    ],
    suppliers: () => [neWebQueryKeys.ppaInvoicing.all(), "suppliers"],
    invoiceDrifts: () => [neWebQueryKeys.ppaInvoicing.all(), "invoiceDrifts"]
  },
  aiChat: {
    all: () => "aiChat",
    adminFeedback: (rating: string, days: number, limit: number) => [
      neWebQueryKeys.aiChat.all(),
      "adminFeedback",
      rating,
      days,
      limit
    ]
  }
};

export { neWebQueryKeys, neWebUrls };
